import {useMeStore} from "../../core/store/me";

export class RoutingService {
  getHasHomeSection() {
    const me = useMeStore.getState().me;
    return (
      me &&
      (me.isResident ||
        me.isOfficer ||
        me.isPatrolOfficer ||
        me.isDispatch ||
        me.isPostCommander ||
        me.isSupervisor ||
        me.isSeniorSupervisor ||
        me.isDispatchSupervisor)
    );
  }
}

export const routingService = new RoutingService();
